export const mixPanelEvents = {
  VIEW_PAGE: 'View Page',
  Error: 'Error',
  LOGIN: 'Login Completed',
  LOGOUT: 'Logout Completed',
  DOCTOR_EVENTS: {
    ADD_DOCTOR: 'Add Doctor Started',
    ADD_DOCTOR_COMPLETED: 'Add Doctor Completed',
    ADD_DOCTOR_CANCELLED: 'Add Doctor Cancelled',
    DOCTOR_INTERACTED: 'Doctor Interacted',
    EDIT_DOCTOR_STARTED: 'Edit Doctor Started',
    EDIT_DOCTOR_COMPLETED: 'Edit Doctor Completed',
    EDIT_DOCTOR_CANCELLED: 'Edit Doctor Cancelled',
    DOCTOR_DELETED: 'Doctor Deleted',
    DOCTOR_FILTER_INTERACTED: 'Doctors Filter Interacted',
    DOCTOR_SEARCH_INTERACTED: 'Doctor Search Interacted',
  },
  USER_EVENTS: {
    ADD_USER_STARTED: 'Add User Started',
    ADD_USER_COMPLETED: 'Add User Completed',
    ADD_USER_CANCELLED: 'Add User Canceled',
    EDIT_USER_STARTED: 'Edit User Started',
    EDIT_USER_COMPLETED: 'Edit User Completed',
    EDIT_USER_CANCELLED: 'Edit User Cancelled',
    USER_INTERACTED: 'User Interacted',
    USER_SUSPENDED_STARTED: 'User Suspended Started',
    USER_REACTIVATE_STARTED: 'User Reactivated Started',
    USER_SUSPENDED_COMPLETED: 'User Suspended Completed',
    USER_REACTIVATE_COMPLETED: 'User Reactivated Completed',
  },
  APP_INTERACTIONS: {
    LOGIN_COMPLETED: 'Login Completed',
    LOGOUT_COMPLETED: 'Logout Completed',
    SIDEBAR_BUTTON_INTERACTED: 'Sidebar Button Interacted',
    SIDEBAR_INTERACTED: 'Sidebar Interacted',
    START_REVIEWING: 'Start Reviewing Interacted',
    START_VALIDATING: 'Start Validating Interacted',
    REVIEW_REFRESH: 'Review Refresh Interacted',
  },
  RECORD_MANAGEMENT: {
    // Record Management - Record Type Review
    DOCUMENT_TYPE_REVIEW_STARTED: 'Document Type Review Started',
    DOCUMENT_TYPE_REVIEW_PAUSED: 'Document Type Review Paused',
    DOCUMENT_TYPE_REVIEW_RESUMED: 'Document Type Review Resumed',
    DOCUMENT_TYPE_REVIEW_COMPLETED: 'Document Type Review Completed',

    // Record Management - Document Review
    DOCUMENT_REVIEW_STARTED: 'Document Review Started',
    DOCUMENT_REVIEW_PAUSED: 'Document Review Paused',
    DOCUMENT_REVIEW_RESUMED: 'Document Review Resumed',
    DOCUMENT_REVIEW_COMPLETED: 'Document Review Completed',

    // Records Management - Validation
    DOCUMENT_VALIDATION_STARTED: 'Document Validation Started',
    DOCUMENT_VALIDATION_PAUSED: 'Document Validation Paused',
    DOCUMENT_VALIDATION_RESUMED: 'Document Validation Resumed',
    DOCUMENT_VALIDATION_COMPLETED: 'Document Validation Completed',

    // Record Management - Rejection
    DOCUMENT_REJECTED : 'Document Rejected', //Reviewer, Validator both

    // Record Management - Escalation
    DOCUMENT_ESCALATED : 'Document Escalated', //Reviewer, Validator both

    // Record Management - Escalation Document Type Review
    ESCALATED_DOCUMENT_TYPE_REVIEW_STARTED :'Escalated Document Type Review Started',
    ESCALATED_DOCUMENT_TYPE_REVIEW_COMPLETED: 'Escalated Document Type Review Completed',

    //Record Management - Escalation Document Review
    ESCALATED_DOCUMENT_REVIEW_STARTED: 'Escalated Document Review Started',
    // ESCALATED_DOCUMENT_REVIEW_PAUSED: 'Escalated Document Review Paused',
    // ESCALATED_DOCUMENT_REVIEW_RESUMED: 'Escalated Document Review Resumed',
    ESCALATED_DOCUMENT_REVIEW_COMPLETED: 'Escalated Document Review Completed',

    // Record Management - Escalation Document Validation
    ESCALATED_DOCUMENT_VALIDATION_STARTED: 'Escalated Document Validation Started',
    ESCALATED_DOCUMENT_VALIDATION_COMPLETED: 'Escalated Document Validation Completed',
  }

};
